<div [ngClass]="{'spinner': true, 'button-view': buttonView, 'small': !pageLoading, 'brand-color': hasBrandColor}">
  <div class="spinner-item"></div>
  <div class="spinner-item"></div>
  <div class="spinner-item"></div>
  <div class="spinner-item"></div>
  <div class="spinner-item"></div>
</div>